export default "__VITE_ASSET__5537e3cc__"